module.exports = __webpack_public_path__ + "static/img/v-consignment-logo.79ffe6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LimitedTimeOfferAd/v-consignment-logo.png
// module id = fDqO
// module chunks = 1